module.exports = __webpack_public_path__ + "909da9adb72e04b1483f2c1530cea077.pdf";